import { render, staticRenderFns } from "./boardStructure.vue?vue&type=template&id=047e6048&scoped=true"
import script from "./boardStructure.vue?vue&type=script&lang=js"
export * from "./boardStructure.vue?vue&type=script&lang=js"
import style0 from "./boardStructure.vue?vue&type=style&index=0&id=047e6048&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e6048",
  null
  
)

export default component.exports